import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { DeptLoginService } from '../service/Dept_Login_service';

@Component({
  selector: 'dda-dept-login',
  templateUrl: './dept-login.component.html',
  styleUrls: ['./dept-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeptLoginComponent implements OnInit {
  Login_Client_Signature:any;
  Session_Timeout:any;
  Random_Session_Id:any;
  Enrypted_Client_Session_Id:any;
  data:any={}
  constructor(public deptservice:DeptLoginService,private router: Router) { }

  ngOnInit()  {
    debugger
    this.deptservice.Geteparichayurl().subscribe(data => {  
      if (data) {
        console.log(data.body.status.detailMessage)
       // this.router.navigate([data.body.status.detailMessage])
       window.location.href=data.body.status.detailMessage
      } 
     })
    
     }
  }
 
  
  
   


